import React from "react";

export default function Footer() {
  return (
    <></>
    // <footer className="admin-footer">
    //   <span>Luali Commodities</span>

    //   <p>
    //     © 2026 Luali TradeTech. All rights reserved.
    //   </p>
    // </footer>
  );
}